import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentCancel.css';

function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="payment-cancel-page">
      <div className="cancel-card">
        <div className="cancel-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2" fill="none"/>
            <path d="M15 9l-6 6M9 9l6 6" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <h1>Payment Cancelled</h1>
        <p className="message">Your payment was cancelled. No charges were made to your account.</p>
        <p className="sub-message">If you experienced any issues during checkout, please contact our support team.</p>
        
        <div className="action-buttons">
          <button onClick={() => navigate('/service2')} className="retry-btn primary">
            Try Again
          </button>
          <button onClick={() => navigate('/')} className="retry-btn secondary">
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;
